import type { EntryPointComponent } from 'react-relay';
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { SidebarIdProjectSettings } from '@jira/navigation-apps__constants/src/SidebarIdProjectSettings.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { getServiceDeskSettingsResources } from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { projectSettingServicedeskRovoServiceRoute } from '@jira/router-routes__project-settings-product-routes-service-desk-routes/src/projectSettingServicedeskRovoServiceRoute.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { servicedeskResolutionManagementPageEntrypoint } from './ui/service-desk-resolution-management/servicedeskResolutionManagementPageEntrypoint.tsx';

const requestResolverRedirectPageEntrypoint = createPageEntryPoint({
	main: {
		root: JSResourceForUserVisible<EntryPointComponent<{}, {}, {}, {}>>(
			/* webpackChunkName: "async-project-settings-service-desk-request-resolver-redirect" */ './ui/service-desk-request-resolver-redirect/RequestResolverRedirect.tsx',
			{ entryFsSsrLiftImportToModule: false },
		),
		getPreloadProps: () => ({}),
	},
});

export const projectSettingServicedeskRovoServiceRouteEntry: ReturnType<typeof createEntry> =
	createEntry(projectSettingServicedeskRovoServiceRoute, () => ({
		group: 'project-settings-servicedesk',
		ufoName: 'jsm-rovo-service-settings',
		layout: serviceProjectLayout,

		navigation: {
			menuId: MenuIdProjects,
			sidebarId: SidebarIdProjectSettings,
		},
		entryPoint: () =>
			fg('rename-rovo-service-to-request-resolver')
				? requestResolverRedirectPageEntrypoint
				: servicedeskResolutionManagementPageEntrypoint,

		resources: [...getServiceDeskSettingsResources(), getConsolidationStateResource()],
		perfMetricKey: 'jsm-rovo-service-settings',

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}));
